import React from 'react';
import {MasterLayout} from 'components/layouts';
import {MyBusinessStatsContainer} from 'components/my-business';
import BusinessZone from 'pages/my-business/BusinessZone.jsx';

import title from 'constants/TitlePages.js';
class MyBusinessStatsPage extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.MyBusinessStatsPage;
  }

  render() {
    return (
      <MasterLayout>
        <MyBusinessStatsContainer params={this.props.match.params}/>
      </MasterLayout>
    );
  }
}

export default BusinessZone(MyBusinessStatsPage);



// WEBPACK FOOTER //
// ./pages/my-business/MyBusinessStatsPage.jsx